import React, { useEffect, useState } from 'react'
import Input from 'components/Input'
// import { filterValues } from 'Helper'
import { withTranslation } from 'react-i18next'
// import useBankInfo from 'hooks/useBankInfo'
// import RadioBtn from 'components/RadioBtn'
import { useFormContext } from 'react-hook-form'
import PhoneNumberInput from 'components/PhoneNumberInput'


export default withTranslation()(function BankTransfer({ t, bank }) {
  const [id, setId] = useState(null)
  
  const { watch, setValue, reset } = useFormContext()

  useEffect(() => {
    reset({
      method: 'bank_transfer',
      account: null,
      acc_name: '',
      amount: '',
      description: '',
    })
  }, [reset])



  useEffect(() => {
    if (watch('account') !== id) {
      setId(watch('account'))
      setValue('acc_name', watch('account') !== '' ? bank?.account_name : '')
    }
  }, [id, bank?.account_name, setValue, watch])


  const fields = [
    {
      name: 'bank_transfer',
      options: [
        {
          name: 'account',
          label: t('redemption.form.0.label'),
          options: [
            {
              value: '',
              label: t('redemption.form.0.placeholder')
            },
            {
              value: bank?.id,
              label: `${bank?.account_no} (${ bank?.bank_name })`
            }
          ]
        }
      ],
    },
    {
      name: 'momo',
      options: [
        {
          name: 'phone_number',
          placeholder: t('redemption.form.4.label'),
          label: t('redemption.form.4.placeholder'),
          type: 'phone'
        },
        {
          name: 'network',
          placeholder: t('redemption.form.5.label'),
          label: t('redemption.form.5.placeholder'),
          options: [
            {
              value: 'mtn',
              label: 'MTN'
            },
            {
              value: 'voda',
              label: 'Vodafone'
            },
            {
              value: 'glo',
              label: 'Glo'
            },
            {
              value: 'tigo',
              label: 'Airtel Tigo'
            },
          ]
        },
      ]
    },
    {
      name: 'acc_name',
      placeholder: t('redemption.form.1.label'),
      label: t('redemption.form.1.placeholder'),
      // value: watch('account') ? bank.account_name : ''
    },
    {
      name: 'amount',
      placeholder: t('redemption.form.2.label'),
      label: t('redemption.form.2.placeholder')
    },
    {
      name: 'reference',
      placeholder: t('redemption.form.3.label'),
      label: t('redemption.form.3.placeholder'),
      rows: 2,
      multiline: true
    }
  ]


  return (
    <>
      {
        fields.map((field) => {
          return (
            <React.Fragment  key={field.name}>
                {
                  field.name === 'bank_transfer' || field.name === 'momo'  ? (
                    <>
                      {
                        field.options.map(({label, name, ...others}) => {
                          return (
                            <React.Fragment  key={label}>
                              { 
                                watch('method') === field.name ? (
                                  <>
                                    {
                                      others.type ? (
                                        <div className="my-5">        
                                          <PhoneNumberInput 
                                            name={name}
                                            label={label}
                                            className="w-full  p-4 rounded-lg bg-input"
                                          />
                                        </div>
                                      ) : (
                                        <div className="my-5"> 
                                          <Input
                                            name={name}
                                            label={label}
                                            options={others?.options}
                                            placeholder={others?.placeholder}
                                            classList=""
                                          />
                                        </div>
                                      )
                                    }
                                  </>
                                ) : null
                              }
                            </React.Fragment>
                          )
                        })
                      }
                    </>
                  ) : (
                    <div className="my-5"> 
                      <Input
                        name={field.name}
                        label={field.label}
                        placeholder={field?.placeholder}
                        classList=""
                        rows={field?.rows ?? ''}
                        multiline={field?.multiline ?? ''}
                      />
                    </div>
                  )
                }
            </React.Fragment>
          )
        })
      }
    </>
  )
})